

// Add event listener for DOMContentLoaded event
if (document.addEventListener) {
  document.addEventListener('DOMContentLoaded', function() {
    'use strict';

    // Class constructor for Komodo Drawer component.
    // Implements Komodo component design pattern
    //
    // @constructor
    // @param {HTMLElement} The element that will be upgraded to be Komodo Drawer.
    var KomodoDrawer = function KomodoDrawer(element) {
      this.element_ = element;
      this.triggerElements = document.querySelectorAll(this.element_.getAttribute("data-drawer-trigger"));
      this.nestedDrawers = this.element_.querySelectorAll(".drawer-nested");
      this.parentContainer = document.querySelector('#mega-nav');

      // Toggle Drawer
      for (var i = 0; i < this.triggerElements.length; i++) {
        this.triggerElements[i].addEventListener('click', this.toggle.bind(this));
      }

      // Manage Nested Drawers
      if (this.nestedDrawers.length > 0) {
        this.manageNestedDrawers();
      }

      this.element_.addEventListener('keydown', this.onKeyDown.bind(this));
    };
    window['KomodoDrawer'] = KomodoDrawer;

    // Store strings for class names defined by this component that are used in
    // Javascript. This allows us to simply change it in one place should we decide
    // to modify at a later date.
    //
    // @enum {string}
    // @private
    KomodoDrawer.prototype.cssClasses_ = {
      TRIGGER_ACTIVE: 'active',
      ACTIVE: 'open',
      CLOSE_ICON: 'drawer-close',
      HEADER: 'drawer-header',
      BODY: 'drawer-body'
    };

    // Store strings for keycodes defined for this component that are used in 
    // Javascript. This allows us to enable keyboard navigation for the component.

    // @enum {string}
    // @private
    KomodoDrawer.prototype.keyCodes = {
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      END: 35,
      HOME: 36,
      ARROW_LEFT: 37,
      ARROW_UP: 38,
      ARROW_RIGHT: 39,
      ARROW_DOWN: 40
    };

    // Toggle the drawer.
    // 
    // @public
    KomodoDrawer.prototype.toggle = function (event) {
      if (this.element_.classList.contains(this.cssClasses_.ACTIVE)) {
        this.close();
      } else {
        this.open(event);
      }
    };

    // Open the drawer.
    //
    // @public
    KomodoDrawer.prototype.open = function (event) {
      this.element_.dispatchEvent(componentHandler.createEvent('opening.komodo.drawer', {}, false, true));
      this.element_.classList.add(this.cssClasses_.ACTIVE);
      event.target.classList.add(this.cssClasses_.TRIGGER_ACTIVE);
      this.element_.focus();
      this.element_.dispatchEvent(componentHandler.createEvent('opened.komodo.drawer', {}, false, true));
    };
    KomodoDrawer.prototype['open'] = KomodoDrawer.prototype.open;

    // Close the drawer.
    //
    // @public
    KomodoDrawer.prototype.close = function () {
      this.element_.dispatchEvent(componentHandler.createEvent('closing.komodo.drawer', {}, false, true));
      if (this.openNested) {
        this.openNested.close();
      }
      for (var i = 0; i < this.triggerElements.length; i++) {
        this.triggerElements[i].classList.remove(this.cssClasses_.TRIGGER_ACTIVE);
      }
      this.element_.classList.remove(this.cssClasses_.ACTIVE);
      this.parentContainer.classList.remove('nested-drawer-active');
      this.element_.dispatchEvent(componentHandler.createEvent('closed.komodo.drawer', {}, false, true));
    };
    KomodoDrawer.prototype['close'] = KomodoDrawer.prototype.close;

    // Manage the Nested Drawer.
    // 
    // @private
    KomodoDrawer.prototype.manageNestedDrawers = function (event) {
      this.openNested = null;
      for (var i = 0; i < this.nestedDrawers.length; i++) {
        var drawer = this.nestedDrawers[i];
        drawer.addEventListener("opening.komodo.drawer", function(event){
          if (this.openNested) {
            this.openNested.close();
          }

          this.openNested = componentHandler.registeredInstances["KomodoDrawer"][event.target.getAttribute("data-komodo-component-id")];
          this.parentContainer.classList.add('nested-drawer-active');
        }.bind(this));
        drawer.addEventListener("closing.komodo.drawer", function(event){
          if (this.openNested.element_ === event.target) {
            this.openNested = null;
          }
        }.bind(this));
      }
    };

    // Bind the keyboard events with the lists.
    // 
    // @public
    KomodoDrawer.prototype.onKeyDown = function (event) {
      switch(event.keyCode) {
        case this.keyCodes.ESCAPE:
          this.close();
          break;
      }
    };

    // The component registers itself. It can assume componentHandler is available
    // in the global scape.
    componentHandler.register({
      constructor: KomodoDrawer,
      classAsString: 'KomodoDrawer',
      cssClass: 'drawer',
      widget: true
    });
  });
} else {
  document.attachEvent('onreadystatechange', function() {
    if (document.readyState === 'complete') {
      // Code for IE10 and below
      'use strict';

      // Class constructor for Komodo Drawer component.
      // Implements Komodo component design pattern
      //
      // @constructor
      // @param {HTMLElement} The element that will be upgraded to be Komodo Drawer.
      var KomodoDrawer = function KomodoDrawer(element) {
        this.element_ = element;
        this.triggerElements = document.querySelectorAll(this.element_.getAttribute("data-drawer-trigger"));
        this.nestedDrawers = this.element_.querySelectorAll(".drawer-nested");

        // Toggle Drawer
        for (var i = 0; i < this.triggerElements.length; i++) {
          this.triggerElements[i].addEventListener('click', this.toggle.bind(this));
        }

        // Manage Nested Drawers
        if (this.nestedDrawers.length > 0) {
          this.manageNestedDrawers();
        }

        this.element_.addEventListener('keydown', this.onKeyDown.bind(this));
      };
      window['KomodoDrawer'] = KomodoDrawer;

      // Store strings for class names defined by this component that are used in
      // Javascript. This allows us to simply change it in one place should we decide
      // to modify at a later date.
      //
      // @enum {string}
      // @private
      KomodoDrawer.prototype.cssClasses_ = {
        TRIGGER_ACTIVE: 'active',
        ACTIVE: 'open',
        CLOSE_ICON: 'drawer-close',
        HEADER: 'drawer-header',
        BODY: 'drawer-body',
      };

      // Store strings for keycodes defined for this component that are used in 
      // Javascript. This allows us to enable keyboard navigation for the component.

      // @enum {string}
      // @private
      KomodoDrawer.prototype.keyCodes = {
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        END: 35,
        HOME: 36,
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40
      };

      // Toggle the drawer.
      // 
      // @public
      KomodoDrawer.prototype.toggle = function (event) {
        if (this.element_.classList.contains(this.cssClasses_.ACTIVE)) {
          this.close();
        } else {
          this.open(event);
        }
      };

      // Open the drawer.
      //
      // @public
      KomodoDrawer.prototype.open = function (event) {
        this.element_.dispatchEvent(componentHandler.createEvent('opening.komodo.drawer', {}, false, true));
        this.element_.classList.add(this.cssClasses_.ACTIVE);
        event.target.classList.add(this.cssClasses_.TRIGGER_ACTIVE);
        this.element_.focus();
        this.element_.dispatchEvent(componentHandler.createEvent('opened.komodo.drawer', {}, false, true));
      };
      KomodoDrawer.prototype['open'] = KomodoDrawer.prototype.open;

      // Close the drawer.
      //
      // @public
      KomodoDrawer.prototype.close = function () {
        this.element_.dispatchEvent(componentHandler.createEvent('closing.komodo.drawer', {}, false, true));
        if (this.openNested) {
          this.openNested.close();
        }
        for (var i = 0; i < this.triggerElements.length; i++) {
          this.triggerElements[i].classList.remove(this.cssClasses_.TRIGGER_ACTIVE);
        }
        this.element_.classList.remove(this.cssClasses_.ACTIVE);
        this.element_.dispatchEvent(componentHandler.createEvent('closed.komodo.drawer', {}, false, true));
      };
      KomodoDrawer.prototype['close'] = KomodoDrawer.prototype.close;

      // Manage the Nested Drawer.
      // 
      // @private
      KomodoDrawer.prototype.manageNestedDrawers = function (event) {
        this.openNested = null;
        for (var i = 0; i < this.nestedDrawers.length; i++) {
          var drawer = this.nestedDrawers[i];
          drawer.addEventListener("opening.komodo.drawer", function(event){
            if (this.openNested) {
              this.openNested.close();
            }

            this.openNested = componentHandler.registeredInstances["KomodoDrawer"][event.target.getAttribute("data-komodo-component-id")];
          }.bind(this));
          drawer.addEventListener("closing.komodo.drawer", function(event){
            if (this.openNested.element_ === event.target) {
              this.openNested = null;
            }
          }.bind(this));
        }
      };

      // Bind the keyboard events with the lists.
      // 
      // @public
      KomodoDrawer.prototype.onKeyDown = function (event) {
        switch(event.keyCode) {
          case this.keyCodes.ESCAPE:
            this.close();
            break;
        }
      };

      // The component registers itself. It can assume componentHandler is available
      // in the global scape.
      componentHandler.register({
        constructor: KomodoDrawer,
        classAsString: 'KomodoDrawer',
        cssClass: 'drawer',
        widget: true
      });
    }
  });
}
